import {getCachedTableDataSlice, getCachedTableResultSelector} from 'src/hooks/common-data-service/cached-table';

import {ActivePlatformAlertsSortField} from '../typedef';

import {activePlatformAlertsStateSelector} from './active-platform-alerts-state.slice';

import type {ActivePlatformAlertsFilters, ClientPlatformAlert} from '../typedef';
import type {AppState} from 'src/store/typedef';


export const activePlatformAlertsSlice = getCachedTableDataSlice<
    ClientPlatformAlert[],
    undefined,
    ActivePlatformAlertsSortField,
    ActivePlatformAlertsFilters
>('ActivePlatformAlerts');

export const activePlatformAlertsActions = activePlatformAlertsSlice.actions;
export const activePlatformAlertsCacheSelector = (state: AppState) =>
    state.platformAlertBuilder.result.cache;
export const activePlatformAlertsDataSelector = (state: AppState) =>
    state.platformAlertBuilder.result;
export const activePlatformAlertsResultSelector = getCachedTableResultSelector(
    activePlatformAlertsCacheSelector,
    activePlatformAlertsStateSelector,
);
